import { Label } from "@/components/ui/label";
import { RoundModeEnum } from "../../pricing-configurator.types";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { ROUND_MODES, ROUNDING_OPTIONS_VALUES } from "../../pricing-configurator.const";

type PricingRoundingRulesProps = {
  roundTo: number;
  onRoundToChange: (value: number) => void;
  roundMode: RoundModeEnum;
  onRoundModeChange: (mode: RoundModeEnum) => void;
  keepAnchorsExact: boolean;
  onKeepAnchorsExactChange: (value: boolean) => void;
};

export const PricingRoundingRules = ({
  roundTo,
  onRoundToChange,
  roundMode,
  onRoundModeChange,
  keepAnchorsExact,
  onKeepAnchorsExactChange,
}: PricingRoundingRulesProps) => {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-medium">Règles d'arrondi</h3>
        <p className="text-xs text-muted-foreground">Appliquer des règles aux prix générés</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-2">
          <Label className="text-sm font-medium">Arrondir à</Label>
          <Select value={roundTo.toString()} onValueChange={(v) => onRoundToChange(parseFloat(v))}>
            <SelectTrigger className="h-8">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ROUNDING_OPTIONS_VALUES.map((option) => (
                <SelectItem key={option.value} value={option.value.toString()}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-sm font-medium">Mode</Label>
          <Select value={roundMode} onValueChange={(v) => onRoundModeChange(v as RoundModeEnum)}>
            <SelectTrigger className="h-8">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ROUND_MODES.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="space-y-3">
        <label className="flex cursor-pointer items-center gap-3 rounded-md border p-3 transition-colors hover:bg-muted/50">
          <Checkbox
            checked={keepAnchorsExact}
            onCheckedChange={(checked) => onKeepAnchorsExactChange(checked === true)}
          />
          <span className="text-sm">Conserver les prix d'ancrage exacts (ne pas arrondir)</span>
        </label>
      </div>
    </div>
  );
};
